
import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import {
  
  searchTicketActivity,
  getTicketsByAgent 
} from "../../../services/AgentServices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHashtag,
  faMobileAlt,
  faInfoCircle,
  faClock,
  faCommentDots,
} from "@fortawesome/free-solid-svg-icons";

export default function SelfAssessment() {
  const [allTickets, setAllTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const ticketsPerPage = 10;
  const [statusCounts, setStatusCounts] = useState({
    Open: 0,
    "In-Progress": 0,
    Resolved: 0,
    "No-Response": 0,
  });

  const clientId = sessionStorage.getItem("clientId");
  const userId = sessionStorage.getItem("userId");

useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const clientId = sessionStorage.getItem("client_id");
      const ticketsRes = await getTicketsByAgent(clientId, userId);

      const ticketList = ticketsRes?.tickets || [];

      const enriched = ticketList.map((t) => {
  const complaint = t.complaints?.[0]; 
  return {
    ...t,
    status: t.status,
    created_at: t.createdAt,
    remark: t.activity_description || "No Remark", 
    device_id: complaint?.device_id || "N/A",
  };
});


      setAllTickets(enriched);
      setFilteredTickets(enriched);
      updateStatusCounts(enriched);
    } catch (err) {
      console.error(err);
      setAllTickets([]);
      setFilteredTickets([]);
    } finally {
      setLoading(false);
    }
  };

  if (userId) fetchData();
}, [userId]);




  const updateStatusCounts = (tickets) => {
    const counts = { Open: 0, "In-Progress": 0, Resolved: 0, "No-Response": 0 };
    tickets.forEach((t) => {
      const st = t.status?.toUpperCase();
      if (st === "OPN") counts.Open++;
      else if (st === "INP") counts["In-Progress"]++;
      else if (st === "CRS") counts.Resolved++;
      else if (st === "CNR") counts["No-Response"]++;
    });
    setStatusCounts(counts);
  };

  const handleFilter = () => {
    if (!fromDate || !toDate) {
      alert("Please select both From and To date.");
      return;
    }

    const from = new Date(fromDate);
    const to = new Date(toDate);
    to.setHours(23, 59, 59, 999);

   
    const displayData = allTickets
      .filter((ticket) => {
        if (!ticket.created_at) return false;
        const dt = new Date(ticket.created_at);
        return dt >= from && dt <= to;
      })
     
      .filter((t) => !["OPN"].includes(t.status?.toUpperCase()));

    setFilteredTickets(displayData);
    setCurrentPage(1);
    updateStatusCounts(displayData);
  };

  const indexOfLast = currentPage * ticketsPerPage;
  const indexOfFirst = indexOfLast - ticketsPerPage;
  const visibleTickets = filteredTickets
    .filter((t) => t.status?.toUpperCase() !== "OPN")
    .slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(filteredTickets.length / ticketsPerPage);

  const getStatusDescription = (code) => {
    switch (code?.toUpperCase()) {
      case "OPN":
        return "Open";
      case "INP":
        return "In-Progress";
      case "CRS":
        return "Resolved";
      case "CNR":
        return "No-Response";
      default:
        return code || "Unknown";
    }
  };
  const handleReset = () => {
    setFromDate("");
    setToDate("");
    setFilteredTickets(allTickets);
    setCurrentPage(1);
    updateStatusCounts(allTickets);
  };

  return (
    <div className="container mt-4">
      <div className="row mb-3">
        <div className="col-md-3">
          <Form.Group>
            <Form.Label>From Date</Form.Label>
            <Form.Control
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Form.Group>
        </div>
        <div className="col-md-3">
          <Form.Group>
            <Form.Label>To Date</Form.Label>
            <Form.Control
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Form.Group>
        </div>
        <div className="col-md-3 d-flex align-items-end gap-2">
          <Button onClick={handleFilter} className="btn btn-primary w-50">
            Show Report
          </Button>
          <Button onClick={handleReset} className="btn btn-secondary w-50">
            Reset
          </Button>
        </div>
        <div className="col-md-3 d-flex align-items-end ms-n12">
          <span className="badge bg-warning text-light me-3 p-1 fs-12">
            In Progress: {statusCounts["In-Progress"]}
          </span>
          <span className="badge bg-danger text-light me-3 p-1 fs-12">
            Resolved: {statusCounts["Resolved"]}
          </span>
          <span className="badge bg-danger text-light me-3 p-1 fs-12">
            No Response: {statusCounts["No-Response"]}
          </span>
        </div>
      </div>

      <div className="table-responsive bg-white p-3 rounded shadow">
        <Table striped bordered hover>
          <thead className="table-dark text-white text-center">
            <tr>
              <th>
                <FontAwesomeIcon icon={faHashtag} /> Ticket ID
              </th>
              <th>
                <FontAwesomeIcon icon={faMobileAlt} /> Device ID
              </th>
              <th>
                <FontAwesomeIcon icon={faInfoCircle} /> Status
              </th>
              <th>
                <FontAwesomeIcon icon={faClock} /> Created At
              </th>
              <th>
                <FontAwesomeIcon icon={faCommentDots} /> Remark
              </th>
            </tr>
          </thead>
          <tbody className="text-center">
            {loading ? (
              [...Array(6)].map((_, i) => (
                <tr key={i}>
                  <td colSpan="5">
                    <Skeleton height={30} />
                  </td>
                </tr>
              ))
            ) : visibleTickets.length > 0 ? (
              visibleTickets.map((ticket) => (
                <tr key={ticket.ticket_id}>
                  <td> {`CBR-${ticket.ticket_id}`}</td>
                  <td>{ticket.device_id|| "N/A"}</td>
                  <td>{getStatusDescription(ticket.status)}</td>
                  <td className="py-3">
                    {ticket.created_at ? (
                      <>
                        <div>
                          {new Date(ticket.created_at).toLocaleDateString(
                            "en-GB"
                          )}
                        </div>
                        <div>
                          {new Date(ticket.created_at).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </div>
                      </>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td>{ticket.remark}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-4">
          <ul className="pagination flex-wrap">
            {Array.from({ length: totalPages }, (_, idx) => (
              <li
                key={idx + 1}
                className={`page-item ${
                  currentPage === idx + 1 ? "active" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(idx + 1)}
                >
                  {idx + 1}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
